function s4 () {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)
}
export const newGuid = () => {
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

//不包含-
export const newGuidWithoutHyphen=()=>{
  return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

// 单号最小长度20
const miniLength = 20
// 获取单号 日期 + 随机字符
export const randomOrderNo = (limitLength) => {
  var d = new Date()
  var month = '' + (d.getMonth() + 1)
  var day = '' + d.getDate()
  var year = d.getFullYear()
  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day
  var ret = year + month + day
  var lengthLeft = limitLength || miniLength
  lengthLeft = lengthLeft < miniLength ? miniLength : lengthLeft
  lengthLeft = lengthLeft - 8
  while (lengthLeft > 0) {
    ret = ret + s4()
    lengthLeft = lengthLeft - 4
  }
  return ret.substring(0, ret.length + lengthLeft)
}
